<template>
  <div>
    <div>
      <SjMenu :data="menuData1" @select="handleSelect" selectedKey="2" />
    </div>
    <div style="margin-top: 10px">
      <SjMenu
        :data="menuData2"
        @select="handleSelect"
        :selectedKey="['1', '2']"
      />
    </div>
    <div style="margin-top: 10px">
      <SjMenu
        :data="menuData1"
        @select="handleSelect"
        theme="highlight"
        selectedKey="1-1-1"
      />
    </div>
    <div style="margin-top: 10px">
      <SjMenu :data="menuData1" @select="handleSelect" theme="shadow" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuData1: [
        {
          key: "1",
          label: "列表内容1",
          children: [
            {
              key: "1-1",
              label: "一段很长很长很长很长很长很长很长很长中文",
              extra: "ctrl M",
              maxHeight: "50px",
              children: [
                {
                  key: "1-1-1",
                  label: "chil",
                  extra: "ctrl Z"
                },
                {
                  key: "1-1-2",
                  label: "chil",
                  extra: "ctrl Z"
                },
                {
                  key: "1-1-3",
                  label: "chil",
                  extra: "ctrl Z"
                },
                {
                  key: "1-1-4",
                  label: "chil",
                  extra: "ctrl Z"
                },
                {
                  key: "1-1-5",
                  label: "chil",
                  extra: "ctrl Z"
                },
                {
                  key: "1-1-6",
                  label: "chil",
                  extra: "ctrl Z"
                }
              ]
            },
            {
              key: "1-2",
              label: "child2",
              disabled: true
            },
            {
              key: "1-3",
              label: "child3",
              children: [
                {
                  key: "1-3-1",
                  label: "child131child131child131child131child131child131",
                  extra: "ctrl F"
                },
                {
                  key: "1-3-2",
                  label: "chil",
                  extra: "ctrl Z"
                }
              ]
            }
          ]
        },
        {
          key: "2",
          label: "列表内容2",
          extra: "F2"
        },
        {
          key: "3",
          label: "列表内容3列表内容3列表内容3列表内容3列表内容3",
          extra: "F3"
        },
        {
          key: "4",
          label: "列表内容4",
          disabled: true
        }
      ],
      menuData2: [
        {
          key: "1",
          label: "列1"
        },
        {
          key: "2",
          label: "列2",
          extra: "F2"
        },
        {
          key: "3",
          label: "列3",
          extra: "F3"
        },
        {
          key: "4",
          label: "列4",
          disabled: true
        }
      ]
    };
  },
  methods: {
    handleSelect(...args) {
      alert(`selected: ${[...args].join(" ")}`);
    }
  }
};
</script>

<style scoped lang="less"></style>
